/**
 * Automatically render loaders, empty state, error state, for a table body
 */
import Empty from "./Empty";
import Error from "./Error";
import Loader from "./Loader";
import Skeleton from "./Skeleton";

export interface NetworkContentsProps {
  isLoading?: boolean;
  isUninitialized?: boolean;
  isError?: boolean;
  isFetching?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
  /**
   * Number of total columns for error/empty states
   */
  size: number;
  /**
   * Loader config for the skeleton
   */
  loader?: {
    rows: number;
    config: number[];
    expanded?: boolean;
    height?: number;
  };
}
const NetworkContents: React.FC<NetworkContentsProps> = ({
  isLoading,
  isUninitialized,
  isError,
  isFetching,
  isEmpty,
  emptyMessage,
  size,
  loader = { rows: 0, config: [] },
  children,
}) => {
  let content = children;
  const showSkeleton = isLoading || isUninitialized;
  if (showSkeleton) {
    const rows = Array.from(new Array(loader.rows));
    content = (
      <>
        {rows.map((_value, index) => (
          <Skeleton
            key={index}
            config={loader.config}
            expand={loader.expanded}
            height={loader.height}
          />
        ))}
      </>
    );
  } else if (isError) {
    content = <Error size={size} />;
  } else if (isEmpty) {
    content = <Empty size={size} message={emptyMessage} />;
  }

  return (
    <>
      {content}
      <Loader
        isLoading={isLoading}
        isUninitialized={isUninitialized}
        isFetching={isFetching}
      />
    </>
  );
};

export default NetworkContents;
